import React from 'react';
import './RulesSection.css';
import { motion } from 'framer-motion';

const RulesSection = () => {
  const rules = [
    { text: "100% Attendance is compulsory for Java", highlight: "100% Attendance" },
    { text: "No Online video access for Java lectures will be provided", highlight: "No Online video access" },
    { text: "Admission can not be transferred or cancelled under any circumstances", highlight: "can not be transferred or cancelled" },
    { text: "Fees non-refundable", highlight: "Fees non-refundable" },
    { text: "Online video access only for Logic Building, Interview Preparation questions and Aptitude will be provided. These videos are completely online and only available in recorded mode", highlight: "Logic Building, Interview Preparation" },
    { text: "All the video lectures will be available only on Core2web mobile app for security purpose", highlight: "Core2web mobile app" }
  ];

  return (
    <section className="ucp-section ucp-rules">
      <div className="rules-container">
        <motion.h2
          className="rules-title"
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
        >
          Rules & <span>Regulations</span>
        </motion.h2>

        <div className="rules-list-wrapper">
          <ul className="rules-list">
            {rules.map((rule, index) => (
              <motion.li
                key={index}
                className="rule-item"
                initial={{ opacity: 0, x: -20 }}
                whileInView={{ opacity: 1, x: 0 }}
                viewport={{ once: true }}
                transition={{ delay: index * 0.1 }}
              >
                <div className="rule-bullet"></div>
                <p className="rule-text">
                  {rule.text}
                </p>
              </motion.li>
            ))}
          </ul>
        </div>
      </div>
    </section>
  );
};

export default RulesSection;
